import budgetActionTypes from "containers/Budget/_actions";
import { syncDirtyBudgets } from "containers/Budget/_actions";
import { push } from "connected-react-router";
import ReactGA from "react-ga4";

const actionTypes = {
    WETLAND_SUBMIT: "WETLAND_SUBMIT",
    WETLAND_DELETE: "WETLAND_DELETE",
    WETLAND_UNFENCED_SUBMIT: "WETLAND_UNFENCED_SUBMIT",
    RIPARIAN_STRIP_SUBMIT: "RIPARIAN_STRIP_SUBMIT",
};

export default actionTypes;

export function submitWetland(farmId, budgetId, block) {
    ReactGA.event({
        category: "Wetland - Fenced",
        action: "Save",
    });
    return (dispatch) => {
        dispatch({ type: actionTypes.WETLAND_SUBMIT, payload: { farmId: farmId, budgetId: budgetId, block: block } });
        dispatch(syncDirtyBudgets(budgetId));
    };
}

export function deleteWetland(farmId, budgetId, wetlandId) {
    ReactGA.event({
        category: "Wetland",
        action: "Delete",
    });
    return (dispatch) => {
        dispatch({ type: actionTypes.WETLAND_DELETE, payload: { farmId: farmId, budgetId: budgetId, wetlandId: wetlandId } });
        dispatch(syncDirtyBudgets(budgetId));
    };
}

export function submitUnfencedWetland(farmId, budgetId, wetland) {
    ReactGA.event({
        category: "Wetland - Unfenced",
        action: "Save",
    });
    return (dispatch) => {
        dispatch({ type: actionTypes.WETLAND_UNFENCED_SUBMIT, payload: { farmId: farmId, budgetId: budgetId, wetland: wetland } });
        dispatch(syncDirtyBudgets(budgetId));
    };
}

export function deleteDrainage(farmId, budget) {
    ReactGA.event({
        category: "Drainage",
        action: "Delete",
    });
    return (dispatch) => {
        dispatch({ type: budgetActionTypes.BUDGET_TOUCHED, payload: { budget } });
        dispatch(push(`/app/farm/${farmId}/analysis/${budget.id}/drainage`));
        dispatch(syncDirtyBudgets(budget.id));
    };
}

export function submitDrainage(farmId, budget) {
    ReactGA.event({
        category: "Drainage",
        action: "Save",
    });
    return (dispatch) => {
        dispatch({ type: budgetActionTypes.BUDGET_TOUCHED, payload: { budget } });
        dispatch(syncDirtyBudgets(budget.id));
    };
}

export function submitRiparianStrip(farmId, budgetId, block) {
    ReactGA.event({
        category: "Riparian Strip",
        action: "Save",
    });
    return (dispatch) => {
        dispatch({ type: actionTypes.RIPARIAN_STRIP_SUBMIT, payload: { farmId: farmId, budgetId: budgetId, block: block } });
        dispatch(syncDirtyBudgets(budgetId));
    };
}
